{
  "language": {
    "thai": "ไทย",
    "english": "English",
    "switchLabel": "เปลี่ยนภาษา",
    "thaiShort": "TH",
    "englishShort": "EN"
  },
  "all": "ทั้งหมด",
  "recommendedPlan": "แพ็กเกจแนะนำ",
  "status": {
    "loading": "กำลังโหลด"
  },
  "nav": {
    "home": "หน้าหลัก",
    "chat": "กล่องข้อความ",
    "crm": "ลูกค้า (CRM)",
    "orders": "ออเดอร์",
    "products": "สินค้า",
    "team": "ทีม",
    "settings": "ตั้งค่า",
    "channels": "ช่องทางแชท",
    "billing": "แพ็กเกจ",
    "aiAssistant": "ผู้ช่วย AI",
    "delivery": "การจัดส่ง",
    "openMenu": "เปิดเมนู",
    "mainAria": "เมนูหลัก",
    "groupWork": "งานประจำวัน",
    "groupSetup": "ตั้งค่าร้าน",
    "attentionBadge_other": "{{count}} แชทรอคนตอบ",
    "attentionBadgeMore": "มากกว่า {{count}} แชทรอคนตอบ"
  },
  "userMenu": {
    "fallbackName": "ผู้ใช้งาน",
    "changePassword": "เปลี่ยนรหัสผ่าน",
    "signOut": "ออกจากระบบ",
    "accountOf": "บัญชีของ {{name}}"
  },
  "merchant": {
    "myStore": "ร้านของฉัน",
    "switchStore": "เปลี่ยนร้าน"
  },
  "routeError": {
    "title": "เกิดข้อผิดพลาดในการโหลด",
    "description": "กรุณาลองใหม่อีกครั้ง",
    "retry": "ลองใหม่"
  },
  "cookies": {
    "dialogLabel": "การตั้งค่าคุกกี้",
    "title": "เว็บไซต์นี้ใช้คุกกี้",
    "body": "เราใช้คุกกี้ที่จำเป็นเพื่อให้ระบบทำงาน และเมื่อท่านยินยอม เราใช้คุกกี้เพื่อการวิเคราะห์และปรับปรุงบริการ อ่านรายละเอียดที่",
    "policyLink": "นโยบายคุกกี้",
    "essentialOnly": "จำเป็นเท่านั้น",
    "acceptAll": "ยอมรับทั้งหมด"
  },
  "subscription": {
    "loadFailed": "ไม่สามารถโหลดข้อมูลแพ็กเกจได้",
    "expired": "หมดอายุแล้ว",
    "freeEndsToday": "แพลนฟรีของท่านจะสิ้นสุดลงในวันนี้",
    "freeEndsIn": "แพลนฟรีของท่านจะสิ้นสุดลงในอีก {{duration}}",
    "buyPlan": "ซื้อแพ็กเกจ",
    "planExpired": "แพ็กเกจของท่านหมดอายุแล้ว กรุณาสมัครแพ็กเกจเพื่อใช้งานต่อ",
    "pendingOrder": "คุณมีคำสั่งซื้อรอชำระเงิน",
    "viewOrders": "ดูคำสั่งซื้อ",
    "planFree": "ทดลองใช้ฟรี",
    "planPaid": "แพ็กเกจแบบชำระเงิน",
    "statusActive": "ใช้งานอยู่",
    "statusPendingPayment": "รอชำระเงิน",
    "statusExpired": "หมดอายุ",
    "statusCancelled": "ยกเลิกแล้ว",
    "noPlan": "ยังไม่มีข้อมูลแพ็กเกจ",
    "startsAt": "เริ่ม {{date}}",
    "endsAt": "สิ้นสุด {{date}}",
    "remaining": "เหลือ {{duration}}",
    "totalSeats": "ที่นั่งทั้งหมด",
    "addonSeats": "เพิ่มจากแพ็กเกจหลัก",
    "addonSeatCount": "+{{count}} ที่นั่ง",
    "daysLeft_other": "{{count}} วัน",
    "seatCount_other": "{{count}} ที่นั่ง"
  },
  "document": {
    "title": "Sight Order — กล่องข้อความเดียวสำหรับร้านค้าไทย"
  }
}
